module.exports = __webpack_public_path__ + "static/media/arrow-1.aba298f2.svg";